import * as Sentry from '@sentry/react'
import {
  reactRouterBrowserTracingIntegration,
  replayIntegration,
  consoleLoggingIntegration,
} from '@sentry/react'
import { useEffect } from 'react'
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom'
import config from './config'

const isDev = config.NODE_ENV === 'development'

const apiOrigin = new URL(config.API_URL).origin

export function initSentry() {
  Sentry.init({
    dsn: config.SENTRY_DSN,
    release: `glimpse-frontend@${config.VERSION || 'unknown'}+${config.COMMIT_SHA || 'dev'}`,
    environment: config.NODE_ENV,
    integrations: [
      reactRouterBrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      replayIntegration(),
      consoleLoggingIntegration({
        levels: ['log', 'info', 'warn', 'error'],
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    debug: isDev,
    enableLogs: isDev,
    tracePropagationTargets: [
      apiOrigin,
      'http://localhost:5900',
      'https://test.glimpse-api.keystonestrategy.io',
    ],
  })

  Sentry.getCurrentScope().setTag('isWeb', config.IS_WEB)
  Sentry.getCurrentScope().setTag('version', config.VERSION)
}

export { Sentry }
